export var DefaultPermissionEnum;
(function (DefaultPermissionEnum) {
    DefaultPermissionEnum["API_CREATE"] = "API_CREATE";
    DefaultPermissionEnum["API_READ"] = "API_READ";
    DefaultPermissionEnum["API_UPDATE"] = "API_UPDATE";
    DefaultPermissionEnum["API_DELETE"] = "API_DELETE";
    DefaultPermissionEnum["WEB_CREATE"] = "WEB_CREATE";
    DefaultPermissionEnum["WEB_READ"] = "WEB_READ";
    DefaultPermissionEnum["WEB_UPDATE"] = "WEB_UPDATE";
    DefaultPermissionEnum["WEB_DELETE"] = "WEB_DELETE";
    DefaultPermissionEnum["PAGE_VIEW"] = "PAGE_VIEW";
})(DefaultPermissionEnum || (DefaultPermissionEnum = {}));
const prefixPermission = (prefix, permissions) => Object.entries(permissions).reduce((acc, [key, value]) => ({
    ...acc,
    [key]: `${prefix}_${value}`,
}), {});
export function generatePermissionForEntity(entityName, customPermissions) {
    const defaultPermissionsPrefixed = prefixPermission(entityName, DefaultPermissionEnum);
    if (!customPermissions) {
        return Object.freeze({ ...defaultPermissionsPrefixed });
    }
    const customPermissionsPrefixed = prefixPermission(entityName, customPermissions);
    return Object.freeze({ ...defaultPermissionsPrefixed, ...customPermissionsPrefixed });
}
//# sourceMappingURL=generatePermissionForEntity.js.map